import { render, staticRenderFns } from "./PlazosList.vue?vue&type=template&id=5d6a14f0"
import script from "./PlazosList.vue?vue&type=script&setup=true&lang=js"
export * from "./PlazosList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports